"use client"

import Link from "next/link"
import { Button } from "@/components/ui/button"
import { AnimatedDiceIcon } from "@/components/animated-dice-icon"
import { KeyboardShortcutsTooltip } from "@/components/keyboard-shortcuts-tooltip"
import { usePathname } from "next/navigation"
import { useState, useEffect } from "react"

export function Footer() {
  const pathname = usePathname()
  const isHomePage = pathname === "/"
  const isResultsPage = pathname.startsWith("/results")
  const [diceIconCount, setDiceIconCount] = useState(5)
  
  // Define footer positioning
  const footerClassName = "relative z-10"

  // Function to handle randomize tower on home page
  const handleRandomizeTower = () => {
    // Update dice icon count
    setDiceIconCount(Math.floor(Math.random() * 6) + 1)
    
    if (isHomePage) {
      // Send keyboard event to trigger randomize on home page
      const event = new KeyboardEvent('keydown', {
        key: 'r',
        code: 'KeyR',
        keyCode: 82,
        which: 82,
        bubbles: true
      })
      document.dispatchEvent(event)
    } else if (isResultsPage) {
      // Send keyboard event to trigger randomize on results page
      const event = new KeyboardEvent('keydown', {
        key: 'r',
        code: 'KeyR',
        keyCode: 82,
        which: 82,
        bubbles: true
      })
      document.dispatchEvent(event)
    }
  }

  return (
    <footer className={`w-full py-6 px-4 md:px-8 lg:px-12 ${footerClassName}`}>
      <div className="w-full flex justify-between items-center">
        {/* Left side - copyright */}
        <div className="text-center md:text-left lg:text-left text-[12px] leading-[16px] uppercase font-funnel text-muted-foreground">
          <p className="mb-1">
            © 2025 NFTotem by{" "}
            <Link
              href="https://ilyakazakov.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-brand-purple transition-colors"
            >
              Ilya Kazakov
            </Link>{" "}
            &{" "}
            <Link
              href="https://antongridz.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-brand-purple transition-colors"
            >
              Anton Gridz
            </Link>
            . All rights reserved.
          </p>
        </div>

                            {/* Right side - Easter Egg only (hidden button for keyboard shortcuts) */}
                    {isHomePage && (
                      <div className="hidden">
                        <KeyboardShortcutsTooltip showEasterEgg={true}>
                          <Button
                            variant="outline"
                            size="icon"
                            className="rounded-lg border-gray-300 text-gray-700 hover:bg-gray-100 transition-all duration-300"
                            onClick={handleRandomizeTower}
                            title="Randomize Tower Order (R)"
                          >
                            <AnimatedDiceIcon dotCount={diceIconCount} />
                            <span className="sr-only">Randomize Tower Order</span>
                          </Button>
                        </KeyboardShortcutsTooltip>
                      </div>
                    )}
      </div>
    </footer>
  )
}
